import { Heading, Tab, Tabs } from '@alefeducation/ui-elements-library-core';
import React from 'react';
import { RNPTabs } from './types';
import {
  SystemRoles,
  CustomRoles,
  SearchBox,
  CreateNewRoleButton,
} from '../../components/RolesAndPermissions';
import CustomRolesCsvActions from '../../components/RolesAndPermissions/CustomRoles/CustomRolesCsvActions';
import { RNPToastComponent } from '../../components/RolesAndPermissions/RNPToaster';
import { FEATURE_TOGGLE } from '../../utils/FeatureToggle';
import useRNP from '../hooks/useRNP';
import { PaginationContext } from '../../components/Pagination/PaginationContext';
import { ROLES_AND_PERMISSIONS } from '../../utils/constants';
import {
  StyledContainer,
  StyledRNPContainer,
  StyledTableHeader,
  StyledTableBody,
  StyledHeaderActions,
} from '../../components/RolesAndPermissions/rolesAndPermissions.styled';

interface Props {
  currentTab: RNPTabs;
}

const RolesAndPermissions = ({ currentTab = RNPTabs.SYSTEM_ROLES }: Props) => {
  const {
    searchText,
    setSearchText,
    selectedTab,
    showCreateNewRoleButton,
    isViewOnlyRole,
    handleTabSelection,
  } = useRNP({ currentTab });

  return (
    <div>
      <StyledContainer>
        <SearchBox onChange={setSearchText} />
      </StyledContainer>
      <StyledRNPContainer>
        <StyledTableHeader>
          <Heading variant="heading-medium">{ROLES_AND_PERMISSIONS}</Heading>
          {showCreateNewRoleButton && !isViewOnlyRole && (
            <StyledHeaderActions>
              {selectedTab === RNPTabs.CUSTOM_ROLES ? (
                <CustomRolesCsvActions
                  trailingAction={<CreateNewRoleButton />}
                />
              ) : (
                <CreateNewRoleButton />
              )}
            </StyledHeaderActions>
          )}
        </StyledTableHeader>

        <StyledTableBody>
          <PaginationContext.Provider value={{ searchText }}>
            <Tabs type="underline">
              <Tab
                label={RNPTabs.SYSTEM_ROLES}
                type="underline"
                active={selectedTab === RNPTabs.SYSTEM_ROLES}
                onClick={handleTabSelection}
              >
                <SystemRoles />
              </Tab>

              {FEATURE_TOGGLE.RNP_CUSTOM_ROLES ? (
                <Tab
                  label={RNPTabs.CUSTOM_ROLES}
                  type="underline"
                  active={selectedTab === RNPTabs.CUSTOM_ROLES}
                  onClick={handleTabSelection}
                >
                  <CustomRoles />
                </Tab>
              ) : (
                <React.Fragment />
              )}
            </Tabs>
          </PaginationContext.Provider>
        </StyledTableBody>
      </StyledRNPContainer>
      <RNPToastComponent />
    </div>
  );
};

export default RolesAndPermissions;
